import { Snapshot } from '../../../../shared/interfaces/snapshot';

export class EmptySnapshot implements Snapshot<never> {
  get(): never {
    throw new Error('No snapshot available');
  }

  update(): never {
    throw new Error('No snapshot available');
  }

  /* eslint-disable-next-line no-empty-function */
  restore(): void {}

  take(): void {
    throw new Error('No snapshot available');
  }

  equal(): boolean {
    throw new Error('No snapshot available');
  }

  exists(): boolean {
    return false;
  }
}
